import { render } from "./PedidoAcompanhamento.vue?vue&type=template&id=0a7b9818&scoped=true&ts=true"
import script from "./PedidoAcompanhamento.vue?vue&type=script&lang=ts"
export * from "./PedidoAcompanhamento.vue?vue&type=script&lang=ts"

import "./PedidoAcompanhamento.vue?vue&type=style&index=0&id=0a7b9818&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7b9818"]])

export default __exports__